export function isValidAuthorization(authorization) {
    if (typeof authorization !== 'string') return false;
    const token = authorization.trim().replace(/^Bearer\s+/i, '');
    const parts = token.split('.');
    return parts.length === 3 && parts.every(Boolean);
}

export function persistSessionState(store) {
    sessionStorage.setItem('state', JSON.stringify(store.state));
}

export function clearSessionState(store) {
    store.state.Authorization = '';
    store.state.userInfo = '';
    sessionStorage.removeItem('state');
}
